import React from 'react';
import {
    View,
    Text,
    TouchableOpacity,
    TextInput,
    Alert,
    FlatList,
    Image,
    ImageBackground,
    TextProps, ViewProps, ScrollView
} from 'react-native';
import { connect } from 'react-redux';
import IAppState from "../Models/App/IAppState";

import {AnyAction} from "redux";


import {StackNavigationProp} from "@react-navigation/stack";
import { RouteProp } from '@react-navigation/native';
import AppText from "./AppText";
import HideableView from "./HideableView";
import SubClientItem from "./SubClientItem";
import IClient from "../Models/Client/IClient";
import ISubClient from "../Models/Client/ISubClient";
import HttpRequest from "../utils/HttpRequest";
import AlertModal from "./AlertModal";
import AppButton from "./AppButton";
import ConfirmionModal from "./ConfirmionModal";


type ProjectsScreenNavigationProp = StackNavigationProp< any, 'Projects'>;
interface IProps {
    client:IClient;
    printCallBack:Function
}
interface IState {
    isInfoOpened:boolean;
    isAddOpened:boolean;
    subClientToAd:ISubClient;
    SubClients:ISubClient[];
    isErrorAlert:boolean;
    showAlert:boolean;
    alertText:string;
    loading:boolean;
    showConfirm:boolean;
    subClientToRemove?:ISubClient
}

export default class ClientItem extends React.Component<IProps & ViewProps> {

    state:IState={
        isInfoOpened:false,
        isAddOpened:false,
        subClientToAd:{name:'',phone:'',address:'',ClientId:this.props.client.id?this.props.client.id:0},
        SubClients:this.props.client.SubClients?this.props.client.SubClients:[],
        isErrorAlert:false,
        showAlert:false,
        alertText:'',
        loading:false,
        showConfirm:false,


    }
    componentDidMount() {

    }
    setSubClientProp<K extends keyof ISubClient>(value:any,key:K){
        let c=this.state.subClientToAd;
        c[key]=value;
        this.setState({clientToAdd:c})

    }
    addSubClient(){
        let c=  this.state.subClientToAd;
        if( c.address=='' || c.name=='' || c.phone==''){
            this.setState({showAlert:true,alertText:'נא למלא את כל הטפס',isErrorAlert:true})
            return;
        }
        this.setState({loading:true})
        HttpRequest('clients/subClient',"POST",{subClient:c}).then((res)=>{
            this.setState({showAlert:true,alertText:'פעולה בוצעה בהצלחה',isErrorAlert:false})
            let clinet=res.data;
            let clients=this.state.SubClients;
            clients.push(clinet);
            this.setState({SubClients:clients})
            //Alert.alert(JSON.stringify(res.data))
        }).catch(e=>{
            this.setState({showAlert:true,alertText:'שגיאת רשת,אנא נסה שוב',isErrorAlert:true})
        }).finally(()=>this.setState({loading:false}))
    }
    removeSubClient(){

        this.setState({showConfirm:false})
        let subClient=this.state.subClientToRemove;
        if(!subClient) return;
        let subClients=this.state.SubClients;
        subClients=subClients.filter(s=>s.id!=subClient?.id)
        this.setState({SubClients:subClients})
        HttpRequest('clients/subClient',"DELETE",{id:subClient.id}).then((result)=>{

        }).catch(e=>{
            console.log(e)
        })
    }
    render() {
        return(
            <View style={{width:'100%',borderBottomColor:'grey',paddingTop:10,paddingBottom:this.state.isInfoOpened?0:10,borderWidth:1,alignItems:'center'}}>
                <View style={{flexDirection:'row',justifyContent:'center',alignItems:'center',paddingLeft:15,paddingRight:15}}>
                    <View style={{flex:0.23,alignItems:'flex-start'}}>
                        <AppText style={{color:'black',fontSize:12,fontWeight:'700',textAlign:'left'}}>{this.props.client.businessName}</AppText>
                    </View>
                    <View style={{flex:0.32,alignItems:'flex-start'}}>
                        <AppText style={{color:'black',fontSize:12,textAlign:'left'}}>{this.props.client.address}</AppText>
                    </View>
                    <View style={{flex:0.23,alignItems:'flex-start'}}>
                        <AppText style={{color:'black',fontSize:12,textAlign:'left'}}>{this.props.client.phone}</AppText>
                    </View>
                    <View style={{flex:0.22,alignItems:'flex-end',}}>
                        <TouchableOpacity style={{width:70,height:20,backgroundColor:this.state.isInfoOpened?'#01B271':'#019FB2',justifyContent:'center',alignItems:'center',borderRadius:25}} onPress={()=>this.setState({isInfoOpened:!this.state.isInfoOpened})}>
                            <AppText style={{color:'#fff',fontWeight:'500',fontSize:12}}>{!this.state.isInfoOpened?'כרטיס לקוח':'סגירת כרטיס'}</AppText>
                        </TouchableOpacity>
                    </View>
                </View>
                {
                    this.state.isInfoOpened&&<HideableView hidden={!this.state.isInfoOpened} style={{width:'100%'}}>
                        <View style={{flexDirection:'row',justifyContent:'space-around',width:'100%',paddingLeft:15,paddingRight:15}}>
                            <AppText>{"ח.פ: "+this.props.client.businessNumber}</AppText>
                            <AppText>{"איש קשר: "+this.props.client.contactName}</AppText>
                            <AppText>{"איש קשר: "+this.props.client.email}</AppText>
                        </View>
                        <View style={{justifyContent:'center',alignItems:'center',marginTop:5,marginBottom:5}}>
                            <AppButton text={'הדפס דווח משלוחים'} onPress={()=>this.props.printCallBack(this.props.client)} width={150} height={25}/>
                        </View>
                        <AppText style={{textAlign:'left',marginLeft:15,color:'#64D0A8',fontSize:14,fontWeight:'700'}}>לקוחות משנה</AppText>
                        <TouchableOpacity onPress={()=>this.setState({isAddOpened:!this.state.isAddOpened})} style={{height:30,width:'100%',backgroundColor:'#64D0A8',paddingLeft:15,paddingRight:15,flexDirection:'row',alignItems:'center'}}>
                            <View style={{width:20,height:20,borderRadius:20,justifyContent:'center',alignItems:'center',borderColor:'white',borderWidth:1}}>
                                <AppText style={{color:'#fff',fontSize:20,lineHeight:25,fontWeight:"400",marginRight:0}}>{this.state.isAddOpened?"-":"+"}</AppText>
                            </View>
                            <AppText style={{color:'white',fontSize:16,lineHeight:30,marginLeft:10,fontWeight:'400'}}>הוספת לקוח משנה</AppText>
                        </TouchableOpacity>
                        <HideableView style={{width:'100%',alignItems:'center',paddingTop:10,backgroundColor:'#64D0A8'}} hidden={!this.state.isAddOpened}>
                            <TextInput placeholderTextColor={'#989898'} onChangeText={(text )=>this.setSubClientProp(text,"name")} style={{height:30,paddingTop:1,paddingBottom:1,width:'50%',borderRadius:25,borderColor:'grey',borderWidth:1,marginLeft:10,textAlign:'right',paddingLeft:10,paddingRight:10}}  placeholder={'שם'}/>
                            <TextInput placeholderTextColor={'#989898'} onChangeText={(text )=>this.setSubClientProp(text,"phone")}  style={{height:30,paddingTop:1,paddingBottom:1,width:'50%',borderRadius:25,borderColor:'grey',borderWidth:1,marginLeft:10,textAlign:'right',paddingLeft:10,paddingRight:10,marginTop:5}}  placeholder={'טלפון'}/>
                            <TextInput placeholderTextColor={'#989898'} onChangeText={(text )=>this.setSubClientProp(text,"address")}  style={{height:30,paddingTop:1,paddingBottom:1,width:'50%',borderRadius:25,borderColor:'grey',borderWidth:1,marginLeft:10,textAlign:'right',paddingLeft:10,paddingRight:10,marginTop:5}}  placeholder={'כתובת'}/>
                            <View style={{flexDirection:'row',marginTop:15,marginBottom:10}}>
                                <AppButton text={'שמירה' } color={'#373737'} isLoading={this.state.loading} onPress={()=>this.addSubClient()} height={25} fontSize={13} />
                                <AppButton text={'ביטול' } color={'#373737'} onPress={()=>this.setState({isInfoOpened:!this.state.isInfoOpened})} fontSize={13} height={25} />

                            </View>
                        </HideableView>
                        <FlatList
                            data={this.state.SubClients}
                            renderItem={({ item }) =><SubClientItem client={item} removeCallBack={(s:ISubClient)=>this.setState({showConfirm:true,subClientToRemove:s})}/>}
                        />

                    </HideableView>
                }
                <AlertModal isError={this.state.isErrorAlert} show={this.state.showAlert} text={this.state.alertText} closeCallBack={()=>this.setState({showAlert:false})}/>
                <ConfirmionModal confirmCallBack={()=>this.removeSubClient()} closeCallBack={()=>this.setState({showConfirm:false})} text={'האם רציתה למחוק'+" "+this.state.subClientToRemove?.name+" ?"} show={this.state.showConfirm}/>

            </View>
        );
    }
}
/*

 */

